<template>
    <main-content >
        <div v-if="$can('read', 'ticket')">
            <kt-panel class="no-mb">
                <kt-panel-header>
                    <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#tickets-list" role="tab" aria-selected="false">
                                {{ $t('label.tickets-list') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ticket-settings" role="tab" aria-selected="false">
                                {{ $t('label.ticket-settings') }}
                            </a>
                        </li>
                    </ul>
                    </kt-panel-header-toolbar>
                    <div class="margin-auto-0">
                        <router-link to="/tickets/create" class="btn btn-success">{{ $t('ticket.btn.add') }}</router-link>
                    </div>
                </kt-panel-header>
            </kt-panel>
            <div class="tab-content">
                <div class="tab-pane active" id="tickets-list">
                    <tickets-list></tickets-list>
                </div>
                <div class="tab-pane" id="ticket-settings">
                    <ticket-settings></ticket-settings>
                </div>
            </div>
        </div>
        <div v-else>
            <ticket-filter :action="filterAction"></ticket-filter>
            <action-bar>
                <a
                        href="https://wa.me/989120510442"
                        target="_blank"
                        class="btn btn-secondary mr-3"
                        v-if="!($can('read', 'ticket'))"
                >
                    <img class="wa-img" src="https://img.icons8.com/officexs/20/000000/whatsapp.png">
                </a>
                <router-link to="/tickets/create" class="btn btn-success">{{ $t('ticket.btn.add') }}</router-link>
            </action-bar>
            <div v-if="status == 'success'">
                <kt-datatable v-bind="commonAccessDatatableProps" ref="datatable"></kt-datatable>
            </div>
        </div>

    </main-content>
</template>

<script>
import { ApiUrl } from '@/common/api.service'
import columns from './datatable/columns'
import commonAccessColumns from './datatable/commonAccessColumns'
import actions from './datatable/actions'
import { AuthorizationHeader } from '@/common/jwt.service'
import mainContent from '@/components/main-content'
import actionBar from '@/components/custom/action-bar'
import ticketFilter from './components/ticket-filter'
import {mapGetters} from "vuex";
import ticketsList from './components/tickets-list'
import ticketSettings from './components/ticket-settings'
import $ from "jquery";

export default {
    components: {
        mainContent,
        actionBar,
        ticketFilter,
        'tickets-list' : ticketsList,
        'ticket-settings' : ticketSettings,
    },
    data() {
        return {
            query: {},
            active_pane: '#tickets-list',
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('ticket/fetchCategories')
        })
    },
    computed: {
        commonAccessDatatableProps() {
            return {
                id: "user_ticket_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('ticket'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: commonAccessColumns,
                actions: actions
            }
        },
        ...mapGetters('ticket', [
            'status'
        ]),
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    },
    mounted() {
        $('a[data-toggle="tab"]').on('show.bs.tab', (e) => {
            this.active_pane = $(e.target).attr("href")
        })
    }
}
</script>

<style>
.margin-auto-0 {
    margin: auto 0;
}
</style>